module.exports = __webpack_public_path__ + "static/media/financing.7cbdc2fb.svg";